module.exports = __webpack_public_path__ + "static/media/suitcase.ec823795.svg";